import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { CommonEnums } from 'src/app/shared/common.enums';
import { RepConn } from '../datapoint/repconn';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { HdfsCmd_Inst } from './hdfscmd_inst';

export class HdfsCommand {
    hdfsCmd_Inst: HdfsCmd_Inst;
    conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: string;
    ref_Cd: string;
    fldr_Id: number;
    repConn: RepConn;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.hdfsCmd_Inst = new HdfsCmd_Inst();
        this.conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.repConn = new RepConn();
    }

    static parse(hdfsCommandTmp: HdfsCommand): HdfsCommand {
        let hdfsCommand: HdfsCommand = new HdfsCommand();
        hdfsCommand.copyFrom(hdfsCommandTmp);
        return hdfsCommand;
    }

    copy(): HdfsCommand {
        let hdfsCommandTmp: HdfsCommand = new HdfsCommand();

        hdfsCommandTmp.hdfsCmd_Inst = this.hdfsCmd_Inst.copy();
        hdfsCommandTmp.conn_Db_Obj_Lnk = this.conn_Db_Obj_Lnk.copy();
        hdfsCommandTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        hdfsCommandTmp.change_Ind = this.change_Ind;
        hdfsCommandTmp.error_Cd = this.error_Cd;
        hdfsCommandTmp.error_Msg = this.error_Msg;
        hdfsCommandTmp.ref_Id = this.ref_Id;
        hdfsCommandTmp.ref_Cd = this.ref_Cd;
        hdfsCommandTmp.fldr_Id = this.fldr_Id;
        hdfsCommandTmp.repConn = this.repConn.copy();

        return hdfsCommandTmp;
    }

    copyFrom(hdfsCommandTmp: HdfsCommand): void {
        this.hdfsCmd_Inst.copyFrom(hdfsCommandTmp.hdfsCmd_Inst);
        this.conn_Db_Obj_Lnk.copyFrom(hdfsCommandTmp.conn_Db_Obj_Lnk);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, hdfsCommandTmp.dxFlow_Obj_Properties);
        this.change_Ind = hdfsCommandTmp.change_Ind;
        this.error_Cd = hdfsCommandTmp.error_Cd;
        this.error_Msg = hdfsCommandTmp.error_Msg;
        this.ref_Id = hdfsCommandTmp.ref_Id;
        this.fldr_Id = hdfsCommandTmp.fldr_Id;
        this.ref_Cd=hdfsCommandTmp.ref_Cd;
        this.repConn = hdfsCommandTmp.repConn;
    }

    compare(hdfsCommandTmp: HdfsCommand): string {
        let diffString = '';
        diffString = this.hdfsCmd_Inst.compare(hdfsCommandTmp.hdfsCmd_Inst);
        if (diffString != '') return diffString;

        if ((this.conn_Db_Obj_Lnk.toString() != hdfsCommandTmp.conn_Db_Obj_Lnk.toString()))
            return 'diff';

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, hdfsCommandTmp.dxFlow_Obj_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "HDFSCommand[id=" + this.hdfsCmd_Inst +
            ",conn_Db_Obj_Lnk=" + this.conn_Db_Obj_Lnk +
            ",dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ",change_Ind=" + this.change_Ind +
            ",error_Cd =" + this.error_Cd +
            ",error_Msg=" + this.error_Msg +
            ",ref_Id=" + this.ref_Id +
            ",fldr_Id=" + this.fldr_Id +
            ",ref_Cd ="+ this.ref_Cd +
            ",repConn=" + this.repConn + "]";
    }
}
